export default function accountSelector(state: any) {
  return state.account;
}
